var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "myinvestment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Idea-details_join_team-8",
    transform: "translate(-1163.000000, -337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(785.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(346.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "myinvestment",
    transform: "translate(32.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#7834FF",
    cx: 22,
    cy: 22,
    r: 21.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "saving",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "012705f3-d8dc-4075-b325-edea6733e893",
    transform: "translate(7.333333, 5.833333)",
    stroke: "#8512FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6533333,11.6216667 L14.6,11.76 C14.1683333,12.76 10.3433333,13.5333333 7.33333333,13.5333333 C4.02,13.5333333 0,12.6 0,11.45 C0,10.7316667 1.05,10.0966667 2.645,9.72166667 L2.66666667,9.72166667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,11.6183333 L14.6666667,16.05 C13.8833333,16.9666667 10.1666667,17.4483333 7.33333333,17.4483333 C4.5,17.4483333 0.783333333,16.7816667 0,15.865 L0,11.4383333",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,14.2066667 C15.5,14.565 16,15.02 16,15.5166667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15.5166667 L16,20.1166667 C15.2166667,21.0333333 11.5,21.515 8.66666667,21.515 C5.83333333,21.515 2.11666667,20.8483333 1.33333333,19.9316667 L1.33333333,16.5983333",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,2.13333333 C16,3.28333333 11.98,4.21666667 8.66666667,4.21666667 C5.35333333,4.21666667 1.33333333,3.28333333 1.33333333,2.13333333 C1.33333333,0.983333333 5.35333333,0.05 8.66666667,0.05 C11.98,0.05 16,0.983333333 16,2.13333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,2.13333333 L16,6.73333333 C15.2166667,7.65 11.5,8.13166667 8.66666667,8.13166667 C5.83333333,8.13166667 2.11666667,7.465 1.33333333,6.54833333 L1.33333333,2.13333333",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5.37333333 C16.8333333,5.73166667 17.3333333,6.18666667 17.3333333,6.68333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,6.68333333 L17.3333333,10.6166667 C16.55,11.5333333 12.8333333,12.015 10,12.015 C7.16666667,12.015 3.45,11.3483333 2.66666667,10.4316667 L2.66666667,7.275",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.d6cbc8a4ad23213e00951b0f4004e30f.svg";
export { ForwardRef as ReactComponent };